import React from 'react';
import Slider from 'react-slick';
import './ourclient.css'; // Import your custom CSS file

// Client logos (replace with your actual image paths)
import one from "../../assets/company logo/2210422170159570-Photoroom.png";
import two from "../../assets/company logo/Cognizant-Logo-Photoroom.png";
import three from "../../assets/company logo/HCL_Technologies-Logo.wine-Photoroom.png";
import four from "../../assets/company logo/IN-SPACe_Logo-Photoroom.png";
import five from "../../assets/company logo/Technology-Company-Logos-3-1200x750-Photoroom.png";
import six from "../../assets/company logo/download-Photoroom (1).png";
import seven from "../../assets/company logo/download-Photoroom.png";
import eight from "../../assets/company logo/paypal.png";
import nine from "../../assets/company logo/secondary-logo-400x276-Photoroom.png";
import ten from "../../assets/company logo/transparent-hd-paypal-logo-701751694777788ilpzr3lary-Photoroom.png";
import one1 from "../../assets/company logo/zoho.png";
import two2 from "../../assets/company logo/pngtree-microsoft-logo-icon-png-image_3588808-Photoroom.png";
import three3 from "../../assets/company logo/download-Photoroom (2).png";
import four4 from "../../assets/company logo/Google_2015_logo.svg-Photoroom.png";
import five5 from "../../assets/company logo/mind_tree_logo_freelogovectors.net_-Photoroom.png";
import six6 from "../../assets/company logo/images-Photoroom.png";
import seven7 from "../../assets/company logo/Zuari-New-Logo-Photoroom.png";



function OurClients() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true, // Enable auto sliding
    autoplaySpeed: 3000, // Slide every 3 seconds
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="our-clients-section">

        <div className="our-clients">
          <h3>Connecting Talent with 300+ Top-Tier Organizations</h3>
          <div className="underline-oueclient"></div>
          <Slider {...settings}>
            <div className="client-item">
              <img src={one} alt="Honda" />
            </div>
            <div className="client-item">
              <img src={two} alt="Digigram" />
            </div>
            <div className="client-item">
              <img src={three} alt="Nexa" />
            </div>
            <div className="client-item">
              <img src={four} alt="Raymond" />
            </div>
            <div className="client-item">
              <img src={five} alt="Hyundai" />
            </div>
            <div className="client-item">
              <img src={six} alt="Poorvika" />
            </div>
            <div className="client-item">
              <img src={seven} alt="Kia" />
            </div>
            <div className="client-item">
              <img src={eight} alt="Kia" />
            </div>
            <div className="client-item">
              <img src={nine} alt="Kia" />
            </div>
            <div className="client-item">
              <img src={ten} alt="Kia" />
            </div>
            <div className="client-item">
              <img src={one1} alt="Kia" />
            </div>
            <div className="client-item">
              <img src={two2} alt="Kia" />
            </div>
            <div className="client-item">
              <img src={three3} alt="Kia" />
            </div>
            <div className="client-item">
              <img src={four4} alt="Kia" />
            </div>
            <div className="client-item">
              <img src={five5} alt="Kia" />
            </div>
            <div className="client-item">
              <img src={six6} alt="Kia" />
            </div>
            <div className="client-item">
              <img src={seven7} alt="Kia" />
            </div>
          
          </Slider>
        </div>
     
    </section>
  );
}

export default OurClients;
